// extracted by mini-css-extract-plugin
export default {"icon":"ActiveIcon_icon__tWZyr","active":"ActiveIcon_active__tWZ-n"};